var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPiccadillyRecords(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1440_2196)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.35547 19.1369H9.35644L9.35547 19.1306V19.1369Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3067 19.137C21.3067 13.3149 16.5873 8.59546 10.7652 8.59546C4.94357 8.59546 0.223633 13.3149 0.223633 19.137H21.3067Z",
    fill: "#F37021"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00804 17.4277C6.02845 17.4443 5.08582 18.1495 4.93066 19.1369H6.37573C6.38011 18.7911 6.66124 18.5119 7.00804 18.5119C7.35532 18.5119 7.63597 18.7911 7.64035 19.1369H9.0859C8.93026 18.15 7.98763 17.4443 7.00804 17.4277Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.008 15.7852C5.1923 15.8041 3.59159 17.3129 3.41211 19.1369H3.70832C3.87905 17.2721 5.45155 16.3406 7.008 16.3644C8.56494 16.3406 10.1379 17.2721 10.3082 19.1369H10.6039C10.4239 17.3129 8.82418 15.8041 7.008 15.7852Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00784 15.0203C4.71207 15.0514 2.67555 16.8467 2.49023 19.1371H2.93382C3.10017 16.7124 5.05498 15.511 7.00784 15.547C8.9607 15.511 10.915 16.7124 11.0823 19.1371H11.5259C11.3401 16.8467 9.3036 15.0514 7.00784 15.0203Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00728 14.2108C4.30441 14.1904 1.90504 16.4229 1.71875 19.137H2.04171C2.22314 16.1389 4.61959 14.6724 7.00728 14.7342C9.39595 14.6724 11.7924 16.1389 11.9733 19.137H12.2968C12.11 16.4229 9.71016 14.1904 7.00728 14.2108Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00838 13.3047C3.80987 13.3368 0.933837 15.8947 0.745117 19.137H1.08073C1.25096 15.5319 4.13235 13.7653 7.00838 13.8295C9.88441 13.7653 12.7658 15.5319 12.9365 19.137H13.2721C13.0829 15.8947 10.2074 13.3368 7.00838 13.3047Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00833 16.6301C5.59683 16.6457 4.28406 17.7123 4.12695 19.137H4.66004C4.68922 18.9201 4.74516 18.7206 4.82298 18.5392C5.20139 17.6661 6.10656 17.223 7.00785 17.2235C8.09493 17.223 9.18737 17.866 9.35566 19.1312C9.35566 19.1336 9.35614 19.1355 9.35614 19.1375H9.88972C9.7331 17.7119 8.42081 16.6457 7.00833 16.6301Z",
    fill: "#424242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00756 14.7343C4.61938 14.6725 2.22342 16.139 2.04199 19.1371H2.48996C2.67479 16.8467 4.71179 15.0519 7.00756 15.0203C9.30333 15.0514 11.3398 16.8467 11.5256 19.1371H11.9736C11.7927 16.139 9.39574 14.6725 7.00756 14.7343Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00773 13.8296C4.1317 13.7654 1.25032 15.5319 1.08008 19.1371H1.71871C1.905 16.423 4.30437 14.1905 7.00724 14.2109C9.7106 14.1905 12.1105 16.423 12.2967 19.1371H12.9354C12.7651 15.5319 9.88327 13.7654 7.00773 13.8296Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00761 15.5469C5.05475 15.5109 3.09994 16.7123 2.93359 19.137H3.41172C3.59119 17.313 5.19191 15.8042 7.00761 15.7853C8.82379 15.8042 10.4235 17.313 10.604 19.137H11.0821C10.9148 16.7123 8.95998 15.5109 7.00761 15.5469Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.05465 17.3713C5.9914 17.3713 5.10568 18.1311 4.9082 19.1369H4.93009C5.08525 18.1501 6.02788 17.4448 7.00747 17.4278C7.98755 17.4443 8.93017 18.1496 9.08533 19.1369H9.20109C9.00459 18.1311 8.11887 17.3713 7.05465 17.3713Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.65918 19.1371H4.71609C4.72533 18.9294 4.76229 18.7285 4.82212 18.5393C4.7443 18.7202 4.68836 18.9202 4.65918 19.1371Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.0077 17.2231C6.10593 17.2227 5.20124 17.6658 4.82283 18.5388C4.76252 18.7285 4.72604 18.9294 4.7168 19.1366H4.90844C5.10591 18.1308 5.99163 17.371 7.05488 17.371C8.1191 17.371 9.00482 18.1308 9.20181 19.1366H9.35551C9.35551 19.1347 9.35551 19.1327 9.35551 19.1303C9.18722 17.8662 8.09478 17.2227 7.0077 17.2231Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 19.1369H0.20088C0.202825 18.4895 0.263624 17.8553 0.376467 17.241C0.161968 17.8392 0.031129 18.4754 0 19.1369Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00822 12.5366C4.03588 12.5843 1.3476 14.5284 0.376759 17.2405C0.263916 17.8553 0.203117 18.4891 0.201172 19.1365H0.48036C0.484738 15.508 3.42692 12.5697 7.0554 12.5697C10.6844 12.5697 13.6261 15.508 13.6304 19.1365H13.9417V18.4161C13.4135 15.1062 10.3959 12.5921 7.00822 12.5366Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.05453 12.5703C3.42654 12.5703 0.48387 15.5086 0.479492 19.1371H0.744089C0.932809 15.8948 3.80884 13.3369 7.00686 13.3048C10.2063 13.3369 13.0814 15.8948 13.2706 19.1371H13.6291C13.6252 15.5086 10.6835 12.5703 7.05453 12.5703Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00769 16.3645C5.45123 16.3406 3.87873 17.2721 3.70801 19.1369H4.1263C4.28341 17.7118 5.59569 16.6456 7.00769 16.63C8.42017 16.6456 9.73294 17.7123 9.88955 19.1369H10.3078C10.1371 17.2721 8.56462 16.3406 7.00769 16.3645Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.00829 18.512C6.66197 18.512 6.38035 18.7912 6.37598 19.137H7.64059C7.63573 18.7912 7.35557 18.512 7.00829 18.512Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.5396 13.0205L14.3027 16.06V19.1369H14.6826V13.0268L14.5396 13.0205Z",
    fill: "#999999"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9214 4.75049H20.666V7.65813H20.7399V15.5659V19.137H20.9214H20.988V16.347V4.75049H20.9214Z",
    fill: "#454545"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7373 13.1243L17.1488 19.137H17.4795V13.1243H16.7373Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.6377 12.8821L18.0234 12.8972V15.3247L18.4189 19.1371H19.1572V17.8861L18.6377 12.8821Z",
    fill: "#757575"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.31 12.8955H19.1572V17.8859V19.1369H19.2871H19.5176V13.1869V12.8955H19.31Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9414 15.6028V18.4161V19.1369H14.0158H14.063H14.3023V16.06V15.6028H13.9414Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.6665 7.6582H19.79V13.6043V19.137H20.6665H20.7404V15.566V7.6582H20.6665Z",
    fill: "#212121"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9883 4.74463V4.75047H21.0223V16.473V19.1369H21.3691H21.4003V7.02969H21.4645H21.5316V4.74463H20.9883Z",
    fill: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.0223 16.473V4.75049H20.9883V16.347C21 16.3884 21.0111 16.4312 21.0223 16.473Z",
    fill: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9883 16.3472V19.1371H21.0223V16.4731C21.0111 16.4313 21 16.3885 20.9883 16.3472Z",
    fill: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.1788 6.81177H21.9609V19.1369H22.1788V6.81177Z",
    fill: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5753 6.82831L22.7227 6.82052V6.81177H22.2324V19.1369H22.7227V9.81523L22.5753 6.82831Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.2322 6.81177H22.1787V19.1369H22.2322V6.81177Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3884 6.78467L22.7226 6.82066L22.5752 6.82844L22.7226 9.81537L23.1837 19.1371H23.9998L23.3884 6.78467Z",
    fill: "#3B3B3B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4795 9.95776V10.9719V13.1242V19.1369H17.7276H18.0228V15.3246V12.897V11.4476V9.95776H17.4795Z",
    fill: "#303030"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6823 4.04761V4.04858H13.4639V8.92757V11.3795H14.6823V13.0269V19.1369H14.8549H15.2265V14.3601V13.0502V9.55939V4.04761H14.6823Z",
    fill: "#121212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7376 13.1242L16.544 10.2876L16.1131 4L15.6865 4.04767H15.8247V7.75883L15.9745 9.94321L16.6034 19.137H16.7182H17.1491L16.7376 13.1242Z",
    fill: "#595959"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5317 7.02979H21.4646H21.4004V19.137H21.4646H21.5317H21.7739V7.02979H21.5317Z",
    fill: "#858585"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.6869 4.04761H15.2812V9.58566V13.0531V13.6577V19.1369H15.825V9.85901V7.75877V4.04761H15.6869Z",
    fill: "#121212"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1440_2196"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPiccadillyRecords);
export default __webpack_public_path__ + "static/media/piccadilly-records.3e118b3f.svg";
export { ForwardRef as ReactComponent };